// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseDiagramShape } from './BaseDiagramShape';
import { NodeShape } from './NodeShape';
import { LineShape } from './LineShape';
import { ContainerShape } from './ContainerShape';
/**
 * 实体模型图表 实体类
 * 实体模型图表存放实体模型
 */
export class DiagramShape extends BaseDiagramShape {
  /** 节点图形 */
  private _nodeShapes: Array<NodeShape>;

  /** 获取：节点图形 */
  public get nodeShapes() {
    return this._nodeShapes;
  }

  /** 设置：节点图形 */
  public set nodeShapes(value: Array<NodeShape>) {
    this._nodeShapes = value;
  }

  /** 线图形 */
  private _lineShapes: Array<LineShape>;

  /** 获取：线图形 */
  public get lineShapes() {
    return this._lineShapes;
  }

  /** 设置：线图形 */
  public set lineShapes(value: Array<LineShape>) {
    this._lineShapes = value;
  }

  /** 容器图形 */
  private _containers: Array<ContainerShape>;

  /** 获取：容器图形 */
  public get containers() {
    return this._containers;
  }

  /** 设置：容器图形 */
  public set containers(value: Array<ContainerShape>) {
    this._containers = value;
  }

  constructor() {
    super();
    this._nodeShapes = new Array<NodeShape>();
    this._lineShapes = new Array<LineShape>();
    this._containers = new Array<ContainerShape>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: DiagramShape, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    if (json.NodeShapes && json.NodeShapes.length > 0) {
      json.NodeShapes.forEach((element: any) => {
        const nodeShape = NodeShape.Create(element);
        // nodeShape.diagram = this;
        this.nodeShapes.push(nodeShape);
      });
    }
    if (json.LineShapes && json.LineShapes.length > 0) {
      json.LineShapes.forEach((element: any) => {
        const lineShape = LineShape.Create(element);
        // lineShape.diagram = this;
        this.lineShapes.push(lineShape);
      });
    }
    if (json.Containers && json.Containers.length > 0) {
      json.Containers.forEach((element: any) => {
        const containerShape = ContainerShape.Create(element);
        // containerShape.diagram = this;
        this.containers.push(containerShape);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    if (this.nodeShapes && this.nodeShapes.length > 0) {
      json.NodeShapes = [];
      this.nodeShapes.forEach((element) => {
        json.NodeShapes.push(element.toJson());
      });
    }
    if (this.lineShapes && this.lineShapes.length > 0) {
      json.LineShapes = [];
      this.lineShapes.forEach((element) => {
        json.LineShapes.push(element.toJson());
      });
    }
    if (this.containers && this.containers.length > 0) {
      json.Containers = [];
      this.containers.forEach((element) => {
        json.Containers.push(element.toJson());
      });
    }
  }

  static Create(json: any): DiagramShape {
    const diagramShape = new DiagramShape();
    diagramShape.Deserialize(json);
    diagramShape.json = json;
    return diagramShape;
  }
}
